import { Component, EventEmitter, Output, inject } from '@angular/core';
import { TokenService } from '../../services/token.service';

export enum EErrorType {
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
}

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styles: [
    `
      :host {
        @apply w-full h-full flex;
      }
    `,
  ],
})
export class ErrorPageComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() cambiarMetodo = new EventEmitter<void>();

  private readonly tokenService = inject(TokenService);

  get errorType(): EErrorType {
    return this.tokenService.errorType;
  }

  getTitulo(): string {
    switch (this.errorType) {
    case EErrorType.EXPIRED:
      return 'Lo sentimos, el enlace que estás utilizando expiró.';
    default:
      return '404 - Pagina no encontrada';
    }
  }

  getDescripcion(): string {
    switch (this.errorType) {
    case EErrorType.EXPIRED:
      return 'Busca en tu bandeja de correo un correo más reciente o comunícate con tu ejecutivo.';

    default:
      return 'La página que buscabas no existe o no se encuentra disponible.';
    }
  }

  getTextoBoton(): string {
    switch (this.errorType) {
    case EErrorType.EXPIRED:
      return 'Iniciar Nuevamente';
    case EErrorType.NOT_FOUND:
      return 'Reintentar';
    default:
      return 'Reintentar';
    }
  }

  onRetry(): void {
    this.retry.emit();
  }

  handleCambiarMetodo(): void {
    this.cambiarMetodo.emit();
  }
}
